/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/e_scooter_medium'
export default icon
